import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=68756e65&"
import script from "./TransactionTable.vue?vue&type=script&lang=ts&"
export * from "./TransactionTable.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports